// extracted by extract-css-chunks-webpack-plugin
module.exports = {"option":"option-selector__option__1nQcB","selected":"option-selector__selected__2g7_V","disabled":"option-selector__disabled__2bM1S"};